import React from 'react';
import { Search, X } from 'lucide-react';

/**
 * A search input that reads as one.
 *
 * The portal styled a bare <input> per page: no icon, no way to clear it, and
 * a placeholder carrying the only clue about what it searched.
 */
function SearchField({ value, onChange, placeholder = 'Search…', label }) {
  return (
    <div className="psearch">
      <span className="psearch__icon"><Search size={14} /></span>
      <input
        type="search"
        className="psearch__input"
        aria-label={label || placeholder}
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
      {value && (
        <button className="psearch__clear" onClick={() => onChange('')} aria-label="Clear search">
          <X size={13} />
        </button>
      )}
    </div>
  );
}

export default SearchField;
